export interface SelectOption {
  label?: string;
  value?: string | number | boolean | object;
  class?: string;
  checked?: boolean;
  color?: string;
  /*eslint-disable-next-line @typescript-eslint/no-explicit-any*/
  data?: any;
  templateName?: string;
  disabled?: boolean;
  iconName?: string;
}
